module.exports = __webpack_public_path__ + "media/images/social-share-button/telegram-56cf68a6d47ac103ba7ca9f743919453.svg";